import { render, staticRenderFns } from "./TransferInfo.vue?vue&type=template&id=1ab6bb38&"
import script from "./TransferInfo.vue?vue&type=script&lang=ts&"
export * from "./TransferInfo.vue?vue&type=script&lang=ts&"
import style0 from "./TransferInfo.vue?vue&type=style&index=0&lang=less&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports